<template>
  <div class="container">
    <v-card-title class="blue">
      <span class="headline white--text">Email Detail</span>
    </v-card-title>

    <v-card-text class="white text-xs-center">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      />
      <iframe
        v-if="email && email.content"
        class="email-pane"
        :srcdoc="email.content"
      />
      <div
        v-if="email && email.attachments && email.attachments.length"
        class="wrapper"
      >
        <a
          v-for="(attch, index) in email.attachments"
          :key="`attch_${index}`"
          class="item-wrapper"
          :href="attch.url"
        >
          <v-icon size="50">file_copy</v-icon>
          <span class="item-name">{{ attch.filename }}</span>
        </a>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Emails',

  data() {
    return {
      email: null,
    };
  },

  computed: {
    ...mapState({
      loading: state => state.emailStore.loading,
    }),
  },

  mounted() {
    const { id } = this.$route.params;

    return this.getEmailDetail(id).then((data) => {
      this.email = data;
    });
  },

  methods: {
    ...mapActions([
      'getEmailDetail',
    ]),
  },
};
</script>

<style lang="scss">
.justfifyEnd {
  display: flex;
  justify-content: flex-end;
}
.templateWrapper {
  width: 100%;
}
.email-pane {
  display: 100%;
  width: 100%;
  height: 550px;
  border: none;
}
.noneDecoration {
  text-decoration: none;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-height: 150px;
}

.item-wrapper {
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  text-decoration: none;color: #737373;
}

.item-name {
  width: 100%;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/email/EmailDetail.vue